import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { PremiumPrice } from 'src/api/internal/schema';
import { PricesList } from '../PricesList';
import * as S from './styles';

const msgs = defineMessages({
  title: { id: 'onboarding_upsell_mobile_bottom_sheet_choose_plan_title' },
  subscribe: { id: 'onboarding_upsell_subscribe_CTA' },
});

export const PricesModal: FC<{
  isOpen: boolean;
  handleClose: () => void;
  prices: PremiumPrice[];
  selectedPrice: PremiumPrice | null;
  setSelectedPrice: (price: PremiumPrice) => void;
  onSubscribe: () => void;
}> = ({ isOpen, handleClose, prices, selectedPrice, setSelectedPrice, onSubscribe }) => {
  const intl = useIntl();

  return (
    <S.PricesModal isOpen={isOpen} handleClose={handleClose} darkCloseIcon>
      <S.ModalTitle>{intl.formatMessage(msgs.title)}</S.ModalTitle>
      <PricesList
        prices={prices}
        selectedPrice={selectedPrice}
        setSelectedPrice={setSelectedPrice}
      />
      <S.CtaButton buttonType="primary" buttonSize="medium" wide onClick={() => onSubscribe()}>
        {intl.formatMessage(msgs.subscribe)}
      </S.CtaButton>
    </S.PricesModal>
  );
};
